import apiForluz from './api';

export class TourBoasVindasService {
  getVerificaTourBoasVindas = async (values) => {
    const response = await apiForluz.get('VerificarTourBoasVindasWEB', {
      params: {
        matricula: values.matricula,
      },
    });

    return response;
  };

  setInsereRegistroBoasVindas = async (values) => {
    const response = await apiForluz.post('InserirRegistroBoasVindasWEB', {
      matricula: values.matricula,
      etapa: values.etapa,
    });

    return response;
  };
}
